/** Shared visual constants for invitation / public registration pages (parity with originals). */

export const registerPrimaryColor = "#333333";
export const registerSecondaryColor = "#666666";

/**
 * Shared TextField sx for outlined registration inputs (parity with inline pages).
 * @param {string} primaryColor
 * @param {boolean} hasError
 */
export function registerOutlinedFieldSx(primaryColor, hasError) {
  const err = !!hasError;
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
      backgroundColor: "rgba(249, 249, 249, 0.8)",
      "& fieldset": {
        borderColor: err ? "#d32f2f" : "#E0E0E0",
        borderWidth: "2px",
      },
      "&:hover fieldset": {
        borderColor: err ? "#d32f2f" : primaryColor,
      },
      "&.Mui-focused fieldset": {
        borderColor: err ? "#d32f2f" : primaryColor,
      },
    },
    "& .MuiInputBase-input::placeholder": {
      color: "text.secondary",
      opacity: 0.7,
    },
    "& .MuiFormHelperText-root": {
      margin: "4px 0 0 0",
      fontSize: "0.75rem",
    },
  };
}
